import * as React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/css'
import * as classNames from 'classnames'
import {
  ButtonClass,
  spacing,
  mixins,
  Primary,
  Secondary,
} from '@sphinx/components-styles'

export interface FileProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  invalid?: boolean
}

const FileInput = styled.input`
  width: 0;
`

const FileLabel = styled.label`
  white-space: nowrap;
`

const FileName = styled.span`
  ${mixins.menu};
`

const getFileLabelClass = (label: string) => css`
  &:hover {
    &::before {
      background-color: ${Primary.navy[20]};
    }
  }
  &::before {
    content: '${label}';
    ${ButtonClass.buttonLight};
    white-space: nowrap;
    padding: 0 ${spacing.xxs};
    margin-right: ${spacing.xxs};
    border-color: ${Primary.navy[20]};
  }
`

const getFileNameClass = (invalid: boolean) => css`
  color: ${invalid ? Secondary.red[100] : Primary.navy[100]};
`

function FileWithRef(
  {
    onChange,
    name,
    id,
    label = 'Choose File',
    invalid,
    className,
    ...props
  }: FileProps,
  ref: React.Ref<HTMLInputElement>
) {
  const [fileName, setFileName] = React.useState('No file chosen')
  const onChangeFile = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name } = e.target.files[0]
      setFileName(name)
      if (onChange) {
        onChange(e)
      }
    },
    [setFileName]
  )

  const selectedFileName = React.useMemo(() => {
    return invalid ? 'Invalid file' : fileName
  }, [invalid, fileName])

  return (
    <>
      <FileInput
        {...props}
        type="file"
        id={id}
        ref={ref}
        name={name}
        onChange={onChangeFile}
      />
      <FileLabel
        htmlFor={id}
        className={classNames(className, getFileLabelClass(label))}
      >
        <FileName className={classNames(getFileNameClass(invalid))}>
          {selectedFileName}
        </FileName>
      </FileLabel>
    </>
  )
}

export const File: React.FC<FileProps> = React.forwardRef(FileWithRef)
